import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-signup-website-and-online-store-card',
  templateUrl: './signup-website-and-online-store-card.component.html',
  styleUrls: ['./signup-website-and-online-store-card.component.scss']
})
export class SignupWebsiteAndOnlineStoreCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
